// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3oreh","upload":"Small_upload__WTL_n","imageWrap":"Small_imageWrap__wim7m","removeBtn":"Small_removeBtn__2A1lH"};